import { lazy, Suspense } from "react";

import { ModalFloating } from "../../../components/ModalFloating";
import { useMemoModal } from "../../../components/Modal";

const LazyPanel = lazy(() => import("./DevPanel"));

export const useDevPanel = () => {
  const modal = useMemoModal(() => (
    <ModalFloating
      title="Debug Panel"
      onClose={() => modal.close()}
      width="min(560px, 100dvw - var(--width-side-bar))"
      height={540}
    >
      <Suspense>
        <LazyPanel />
      </Suspense>
    </ModalFloating>
  ));
  return modal;
};
